import { TranslationService } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';
import { Component, OnInit, Input } from '@angular/core';
import { EquipmentIdentifier, EquipmentLog } from '../equipment-log.model';

@Component({
  selector: 'app-equipment-log',
  templateUrl: './equipment-log.component.html',
  styleUrls: ['./equipment-log.component.scss']
})
export class EquipmentLogComponent implements OnInit {

  @Input() equipmentIdentifier: EquipmentIdentifier;

  ngOnChanges() {
    this.load();
  }


  equipmentLogs = new Array<EquipmentLog>();

  constructor(private appServerAPI: AppServerAPI, public translationService: TranslationService) { }

  ngOnInit() {
    this.load();
  }

  load() {
    if (this.equipmentIdentifier == null) {
      return;
    }
    this.appServerAPI.execute<EquipmentLog[]>('/client/admin/equipment/get-log', this.equipmentIdentifier).subscribe(response => {
      const tempEquipmentLogs = new Array<EquipmentLog>();
      response.forEach(equipmentLog =>
        tempEquipmentLogs.push(new EquipmentLog(equipmentLog))
      );
      this.equipmentLogs = tempEquipmentLogs;
    })
  }

}
